/**
 * @generated SignedSource<<08320bad3ddb2e7b9dc7d91cbb4e206f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssignmentDueAtStatus = "DUE_SOON" | "NONE" | "OVERDUE" | "%future added value";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserAssignments$data = {
  readonly flowsByAssignedToId: {
    readonly nodes: ReadonlyArray<{
      readonly assignmentDueAtStatus: AssignmentDueAtStatus | null | undefined;
      readonly assignmentStatus: AssignmentStatus;
      readonly module: {
        readonly flowId: UUID;
        readonly programType: ProgramType | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly rowId: UUID;
      readonly " $fragmentSpreads": FragmentRefs<"StatusChip_flow">;
    }>;
  };
  readonly " $fragmentType": "UserAssignments";
};
export type UserAssignments$key = {
  readonly " $data"?: UserAssignments$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAssignments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAssignments",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "linkedType": "MODULE"
          }
        },
        {
          "kind": "Literal",
          "name": "includeArchived",
          "value": "YES"
        }
      ],
      "concreteType": "FlowsConnection",
      "kind": "LinkedField",
      "name": "flowsByAssignedToId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Flow",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StatusChip_flow"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assignmentDueAtStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assignmentStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Module",
              "kind": "LinkedField",
              "name": "module",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "flowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "programType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "flowsByAssignedToId(condition:{\"linkedType\":\"MODULE\"},includeArchived:\"YES\")"
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "03fffdfd4e39e92acc7f6e2ef4623b52";

export default node;
